import IEpiserverContext from '@episerver/spa-core/Core/IEpiserverContext';
import IInitializableModule from '@episerver/spa-core/Core/IInitializableModule';
import IServiceContainer from '@episerver/spa-core/Core/IServiceContainer';
import IStateReducerInfo from '@episerver/spa-core/Core/IStateReducerInfo';
import UpdateBusinessDeliverySlotSlice from './UpdateBusinessDeliverySlotSlice';

export default class UpdateBusinessDeliverySlotInitializableModule implements IInitializableModule {

  protected name: string = 'update Business Delivery Slot module';

  public GetName(): string {
    return this.name;
  }

  public ConfigureContainer(container: IServiceContainer): void {
  }

  public StartModule(context: IEpiserverContext): void {
  }

  public GetStateReducer(): IStateReducerInfo<any> | null {
    return {
      stateKey: 'updateBusinessDeliverySlot',
      reducer: UpdateBusinessDeliverySlotSlice,
    };
  }
}
